import { LogoWhite, LogoMixed } from '../icons';
import LinkExternal from '@components/common/LinkExternal';
import { useRouter } from 'next/router';
import Link from './Link';
import SocialMediaLink from './Footer/SocialMediaLink/SocialMediaLink';
import { Background, SocialWrapper, Heading, Column1, Column2, Column3 } from './Footer.styles';
import Container from '@components/common/Container';

export default function Footer() {
  const router = useRouter();
  const path = router.pathname;
  return (
    <Background>
      <Container>
        <Column1>
          <Link href="/">
            <LogoWhite height="67" />
          </Link>
          <p>&copy; {new Date().getFullYear()} Archimedes</p>
        </Column1>
        <Column2>
          <Heading>Questions?</Heading>
          <p>
            Join us on Discord! Chat with us anytime and join our Agora, our community call, to get updates and ask
            questions.
          </p>
          <SocialWrapper>
            <SocialMediaLink type="discord" />
            <SocialMediaLink type="twitter" />
            <SocialMediaLink type="medium" />
          </SocialWrapper>
        </Column2>
        <Column3>
          <Heading>Resources</Heading>
          <Link href="/about">About</Link>
          <LinkExternal href="https://docs.archimedesfi.com">Documentation</LinkExternal>
          <LinkExternal href="https://github.com/thisisarchimedes/Archimedes_Finance">GitHub</LinkExternal>
          <LinkExternal href="https://docs.archimedesfi.com/archimedes-finance-whitepaper">Whitepaper</LinkExternal>
          <LinkExternal href="https://careers.archimedesfi.com">
            Careers -&nbsp;<strong>We&apos;re Hiring!</strong>
          </LinkExternal>
          <LinkExternal href="https://app.uniswap.org/#/swap?outputCurrency=0x73c69d24ad28e2d43d03cbf35f79fe26ebde1011">
            Buy ARCH Tokens
          </LinkExternal>
          <LinkExternal href="https://docs.archimedesfi.com/terms-of-service">Terms of service</LinkExternal>
          <LinkExternal href="https://docs.archimedesfi.com/privacy-policy">Privacy policy</LinkExternal>
          <LinkExternal href="https://docs.archimedesfi.com/risks-disclosure-statement">
            Risk Disclosure Statement
          </LinkExternal>
          <LinkExternal href="https://docs.archimedesfi.com/legal-notice">Legal Notice</LinkExternal>
        </Column3>
      </Container>
      {path === '/open-position' && <div className="h-72 lg:hidden">&nbsp;</div>}
    </Background>
  );
}
